import { render } from "./diapo.vue?vue&type=template&id=b1caa356&scoped=true"
import script from "./diapo.vue?vue&type=script&lang=js"
export * from "./diapo.vue?vue&type=script&lang=js"

import "./diapo.vue?vue&type=style&index=0&id=b1caa356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1caa356"]])

export default __exports__